import { css } from 'styled-components';

const baseButtonStyle = css`
    font-family: ${(props) => props.theme.app.font};
    font-size: 13px;
    font-weight: 500;
    color: ${(props) => props.theme.app.component.button.primary.default.textColor};
    border: none;
    border-radius: ${(props) => props.theme.app.component.button.borderRadius};
    padding: 7px 14px;
    height: 34px;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    transition: all 0.15s;
    position: relative;
    text-decoration: none;
     line-height: 1.4;
`;

export const buttonStyle = css<{ disabled?: boolean }>`
    ${baseButtonStyle};
    background-color: ${(props) =>
        !props.disabled ? props.theme.app.component.button.primary.default.backgroundColor : props.theme.app.component.button.disabled.backgroundColor};
    ${(props) =>
        !props.disabled &&
        `
    &:hover:not([disabled]) {
        cursor: pointer;
            color: ${props.theme.app.component.button.primary.default.textColor};
            background-color: ${tint(props.theme.app.component.button.primary.default.backgroundColor, 16)};
    }
    `}
`;

export const linkButtonStyle = css<{ $disabled?: boolean }>`
    ${baseButtonStyle};
    background-color: ${(props) =>
        !props.$disabled ? props.theme.app.component.button.primary.default.backgroundColor : props.theme.app.component.button.disabled.backgroundColor};
    ${(props) =>
        !props.$disabled &&
        `
        &:hover {
            cursor: pointer;
            color: ${props.theme.app.component.button.primary.default.textColor};
            background-color: ${tint(props.theme.app.component.button.primary.default.backgroundColor, 16)};
        }
    `}
`;

export const tint = (hex: string, amount: number) => {
    let R = parseInt(hex.substring(1, 3), 16);
    let G = parseInt(hex.substring(3, 5), 16);
    let B = parseInt(hex.substring(5, 7), 16);

    const getSingle = (number: number) => Math.round((number * (100 + amount)) / 100);

    R = getSingle(R);
    G = getSingle(G);
    B = getSingle(B);

    R = R < 255 ? R : 255;
    G = G < 255 ? G : 255;
    B = B < 255 ? B : 255;

    const getDouble = (number: number) => (number.toString(16).length === 1 ? `0${number.toString(16)}` : number.toString(16));

    const RR = getDouble(R);
    const GG = getDouble(G);
    const BB = getDouble(B);

    return `#${RR}${GG}${BB}`;
};
